module.exports = __webpack_public_path__ + "static/img/inviteBtn.289905af.jpg";